export const bulkApiErrorPropertyMapping = {
  // Ads
  AdText: 'Text',
  AdTitle: 'Title',
  AdId: 'Id',
  AdDisplayUrl: 'DisplayUrl',
  AdDisplayURL: 'DisplayUrl',
  AdDescription: 'Text',
  AdDestinationUrl: 'DestinationUrl',
  AdDestinationURL: 'DestinationUrl',
  AdType: 'Type',
  AppMediaUrl: 'MediaUrl',
  AdTitleAndDescription: 'Title',

  // Keywords
  KeywordId: 'Id',
  KeywordStatus: 'Status',
  KeywordDestinationUrl: 'DestinationUrl',
  KeywordParam1: 'Param1',
  KeywordParam2: 'Param2',
  KeywordParam3: 'Param3',
  KeywordText: 'Text',
  KeywordMatchType: 'MatchType',

  // Others
  TrackingTemplate: 'TrackingUrlTemplate',
  CustomParameters: 'UrlCustomParameters',
};
